import { CssBaseline, ThemeProvider } from "@mui/material";
import { createTheme } from "@mui/material/styles";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { themeSettings } from "theme";
import Layout from "scenes/layout";
import CytoGPT from "scenes/cytogpt";
import CytoRNA from "scenes/cytorna";
import Experiments from "scenes/experiments";

import { PlotDataProvider } from './providers/PlotDataProvider'; 
import { GPTDataProvider } from "providers/GPTDataProvider";

function App() {
  const mode = useSelector((state) => state.global.mode);
  const theme = useMemo(() => createTheme(themeSettings(mode)), [mode]);
  return (
    <div className="app">
      <BrowserRouter>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <PlotDataProvider> {/* Wrap your app with the provider */}
          <GPTDataProvider>
            <Routes>
              <Route element={<Layout />}>
                <Route path="/" element={<Navigate to="/cytogpt" replace />} />
                <Route path='/cytogpt' element={ <CytoGPT />} />
                <Route path='/experiments' element={ <Experiments />} />
                <Route path='/cytorna' element={ <CytoRNA />} />
              </Route>
            </Routes>
          </GPTDataProvider>
        </PlotDataProvider>
        </ThemeProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
